(function () {
  const sectionSelector = [
    '[id$="__featured_collection_zVppNp"]',
    '[id$="__kartolog_home_accessories"]',
    '[id$="__kartolog_home_sealed"]',
    '[id$="__kartolog_home_set_1"]',
    '[id$="__kartolog_home_set_2"]',
    '[id$="__kartolog_home_set_3"]',
    '[id$="__kartolog_home_bulk"]',
    '[id$="__kartolog_home_popular_products"]',
    '[id$="__kartolog_home_cart_pending"]',
    '[id$="__kartolog_home_valuable_cards"]',
    '[id$="__kartolog_home_other_cards"]',
  ].join(',');

  function enableMouseDrag(slider) {
    if (!slider || slider.dataset.kartologDragReady === 'true') return;
    slider.dataset.kartologDragReady = 'true';

    let dragging = false;
    let startX = 0;
    let startScrollLeft = 0;
    let moved = false;
    const dragThreshold = 7;

    slider.addEventListener('dragstart', (event) => event.preventDefault());

    slider.addEventListener('mousedown', (event) => {
      if (event.button !== 0) return;
      if (slider.scrollWidth <= slider.clientWidth + 2) return;

      dragging = true;
      moved = false;
      startX = event.pageX;
      startScrollLeft = slider.scrollLeft;
    });

    window.addEventListener('mousemove', (event) => {
      if (!dragging) return;
      const distance = event.pageX - startX;
      if (Math.abs(distance) > dragThreshold) {
        moved = true;
        slider.classList.add('is-dragging');
      }
      if (!moved) return;
      slider.scrollLeft = startScrollLeft - distance;
      event.preventDefault();
    });

    window.addEventListener('mouseup', () => {
      if (!dragging) return;
      dragging = false;
      slider.classList.remove('is-dragging');
    });

    slider.addEventListener(
      'click',
      (event) => {
        if (!moved) return;
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      },
      true,
    );
  }

  function addViewAllCard(section) {
    if (!section) return;

    const sourceLink = section.querySelector('.collection__view-all a[href]');
    const slider = section.querySelector('ul.product-grid, ul.slider, .product-grid.slider, .product-grid');
    if (!sourceLink || !slider) return;

    slider.querySelectorAll('.kartolog-view-all-item').forEach((item) => item.remove());

    const item = document.createElement(slider.tagName === 'UL' || slider.tagName === 'OL' ? 'li' : 'div');
    item.className = 'grid__item slider__slide kartolog-view-all-item';

    const link = document.createElement('a');
    link.className = 'kartolog-view-all-card';
    link.href = sourceLink.href;
    link.setAttribute('aria-label', 'Tümünü gör');
    link.innerHTML = '<span>Tümünü Gör</span><i aria-hidden="true"></i>';

    item.appendChild(link);
    slider.appendChild(item);
  }

  function addSideButtons(section) {
    if (!section || section.dataset.kartologSideButtonsReady === 'true') return;

    const slider = section.querySelector('ul.product-grid, ul.slider, .product-grid.slider, .product-grid');
    if (!slider) return;

    section.dataset.kartologSideButtonsReady = 'true';

    const nav = document.createElement('div');
    nav.className = 'kartolog-slider-nav';

    const previous = document.createElement('button');
    previous.type = 'button';
    previous.className = 'kartolog-slider-nav__button kartolog-slider-nav__button--prev';
    previous.setAttribute('aria-label', 'Önceki ürünler');
    previous.innerHTML = '<span aria-hidden="true"></span>';

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'kartolog-slider-nav__button kartolog-slider-nav__button--next';
    next.setAttribute('aria-label', 'Sonraki ürünler');
    next.innerHTML = '<span aria-hidden="true"></span>';

    function scroll(direction) {
      const amount = Math.max(260, slider.clientWidth * 0.82);
      slider.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    previous.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      scroll(-1);
    });

    next.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      scroll(1);
    });

    nav.append(previous, next);
    section.querySelector('.collection')?.appendChild(nav);
  }

  function linkSectionHeading(section) {
    if (!section || section.dataset.kartologHeadingLinkReady === 'true') return;

    const sourceLink = section.querySelector('.collection__view-all a[href]');
    const heading = section.querySelector('.collection__title .title, .title-wrapper-with-link .title, h2.title, h1.title');
    if (!sourceLink || !heading) return;

    section.dataset.kartologHeadingLinkReady = 'true';

    const existingLink = heading.querySelector('a[href]');
    if (existingLink) {
      existingLink.href = sourceLink.href;
      existingLink.classList.add('kartolog-heading-link');
      return;
    }

    const link = document.createElement('a');
    link.href = sourceLink.href;
    link.className = 'kartolog-heading-link';
    link.innerHTML = heading.innerHTML;
    heading.replaceChildren(link);
  }

  function setup() {
    document.querySelectorAll(sectionSelector).forEach((section) => {
      linkSectionHeading(section);
      addViewAllCard(section);
      addSideButtons(section);
      section.querySelectorAll('.slider, .slider--desktop, .slider--tablet, .product-grid').forEach(enableMouseDrag);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', setup);
})();
